import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-access-page',
  templateUrl: './no-access-page.component.html',
  styleUrls: ['./no-access-page.component.css']
})
export class NoAccessPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  
  navigateToPrevUrl(): void {
    history.go(-2);
  }
}
